import AdminConfig from './admin';

import ClientView from './client';


export default {
  name : 'codebarre',

  type : 'module',
  
  label: 'Code barre',

  components: {

    admin: AdminConfig,

    client: ClientView

  },

  settings: {
    icon: 'mdi-barcode',
  }
}